module.exports = __webpack_public_path__ + "static/media/coaches-icon.0131a567.svg";